import { Box, styled, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import { capitalizeStage } from 'components/featured/Deals/components/DealDetailsMain/utils';

import { muiStyles } from './muiStyles';

import { ACTION_ROUTE, ICON_MAP } from './data';
import { QuickActionButtonProps } from './types';

const StyledLink = styled(Link)(() => ({ ...muiStyles.stylesLink }));

const QuickActionButton = ({ variant, handleCloseSearch }: QuickActionButtonProps) => {
  const Icon = ICON_MAP[variant];
  const path = ACTION_ROUTE[variant];

  return (
    <StyledLink
      to={path}
      state={{ modal: true }}
      onClick={(e) => {
        e.stopPropagation();
        handleCloseSearch();
      }}
    >
      <Box sx={muiStyles.root}>
        <Icon />
      </Box>
      <Typography variant='responsiveButtonMedium'>Create {capitalizeStage(variant)}</Typography>
    </StyledLink>
  );
};

export default QuickActionButton;
